import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Chip,
  TextField,
  InputAdornment,
  Menu,
  ListItemIcon,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Avatar,
} from '@mui/material';
import {
  Download,
  Print,
  Refresh,
  Search,
  Business,
  TrendingUp,
  CheckCircle,
  Schedule,
  PictureAsPdf,
  Description,
  Visibility,
  Close,
  Person,
  Home,
  CalendarToday,
  AttachMoney,
  AccountBalance,
} from '@mui/icons-material';

const BranchSummaryDetails = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filters, setFilters] = useState({
    branch: '',
    fromDate: '',
    toDate: '',
    searchTerm: ''
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [viewDialogOpen, setViewDialogOpen] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);

  const sampleData = [
    {
      sno: 1,
      bookingId: 'BK001',
      customerName: 'Amit Gupta',
      plotNo: 'P101',
      bookingDate: '2025-01-01',
      plotAmount: 500000,
      paidAmount: 100000,
      status: 'Booked',
      branch: 'Mumbai'
    },
    {
      sno: 2,
      bookingId: 'BK002',
      customerName: 'Jane Smith',
      plotNo: 'P102',
      bookingDate: '2025-01-02',
      plotAmount: 750000,
      paidAmount: 750000,
      status: 'Alloted',
      branch: 'Delhi'
    },
    {
      sno: 3,
      bookingId: 'BK003',
      customerName: 'Mike Johnson',
      plotNo: 'P103',
      bookingDate: '2025-01-03',
      plotAmount: 600000,
      paidAmount: 150000,
      status: 'Booked',
      branch: 'Bangalore'
    },
    {
      sno: 4,
      bookingId: 'BK004',
      customerName: 'Sarah Wilson',
      plotNo: 'P104',
      bookingDate: '2025-01-04',
      plotAmount: 800000,
      paidAmount: 400000,
      status: 'Booked',
      branch: 'Mumbai'
    },
    {
      sno: 5,
      bookingId: 'BK005',
      customerName: 'David Brown',
      plotNo: 'P105',
      bookingDate: '2025-01-05',
      plotAmount: 650000,
      paidAmount: 650000,
      status: 'Alloted',
      branch: 'Delhi'
    }
  ];

  const branches = ['All', 'Mumbai', 'Delhi', 'Bangalore', 'Chennai', 'Pune'];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterChange = (field, value) => {
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Export functions
  const handleExportClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setAnchorEl(null);
  };

  const handleExportCsv = () => {
    const headers = ["S.No", "Booking ID", "Customer Name", "Plot No", "Booking Date", "Plot Amount", "Paid Amount", "Due Amount", "Status", "Branch"];
    const rows = filteredData.map((item, index) => [
      index + 1,
      item.bookingId,
      item.customerName,
      item.plotNo,
      item.bookingDate,
      item.plotAmount,
      item.paidAmount,
      item.plotAmount - item.paidAmount,
      item.status,
      item.branch
    ]);

    const csvContent = [headers, ...rows]
      .map(row => row.map(field => `"${field}"`).join(','))
      .join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `branch_summary_details_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExportPdf = () => {
    const printWindow = window.open('', '_blank');
    printWindow.document.write('<html><head><title>Branch Summary Details Report</title>');
    printWindow.document.write('<style>');
    printWindow.document.write(`
      body { font-family: Arial, sans-serif; margin: 20px; }
      h1 { color: #333; text-align: center; }
      table { width: 100%; border-collapse: collapse; margin-top: 20px; }
      th, td { border: 1px solid #ddd; padding: 12px; text-align: left; }
      th { background-color: #536DFE; color: white; font-weight: bold; }
      tr:nth-child(even) { background-color: #f2f2f2; }
      .total-row { background-color: #f0f0f0; font-weight: bold; }
      .number { text-align: right; font-family: monospace; }
      .center { text-align: center; }
    `);
    printWindow.document.write('</style></head><body>');
    printWindow.document.write('<h1>Branch Summary Details Report</h1>');
    printWindow.document.write(`<p><strong>Generated on:</strong> ${new Date().toLocaleDateString()}</p>`);
    printWindow.document.write(`<p><strong>Total Bookings:</strong> ${filteredData.length}</p>`);
    printWindow.document.write('<table>');
    printWindow.document.write('<thead><tr>');
    ["S.No", "Booking ID", "Customer Name", "Plot No", "Booking Date", "Plot Amount (Rs.)", "Paid Amount (Rs.)", "Due Amount (Rs.)", "Status", "Branch"].forEach(header => {
      printWindow.document.write(`<th>${header}</th>`);
    });
    printWindow.document.write('</tr></thead><tbody>');
    filteredData.forEach((item, index) => {
      printWindow.document.write(`
        <tr>
          <td>${index + 1}</td>
          <td>${item.bookingId}</td>
          <td>${item.customerName}</td>
          <td>${item.plotNo}</td>
          <td>${item.bookingDate}</td>
          <td class="number">Rs. ${item.plotAmount.toLocaleString()}</td>
          <td class="number">Rs. ${item.paidAmount.toLocaleString()}</td>
          <td class="number">Rs. ${(item.plotAmount - item.paidAmount).toLocaleString()}</td>
          <td class="center">${item.status}</td>
          <td>${item.branch}</td>
        </tr>
      `);
    });
    printWindow.document.write(`
      <tr class="total-row">
        <td colspan="5"><strong>Total</strong></td>
        <td class="number">strong>Rs. ${totals.totalAmount.toLocaleString()}</strong></td>
        <td class="number">strong>Rs. ${totals.totalPaid.toLocaleString()}</strong></td>
        <td class="number">strong>Rs. ${totals.totalDue.toLocaleString()}</strong></td>
        <td colspan="2"></td>
      </tr>
    `);
    printWindow.document.write('</tbody></table>');
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
  };

  const handleExport = (type) => {
    if (type === 'csv') {
      handleExportCsv();
    } else if (type === 'pdf') {
      handleExportPdf();
    }
    handleExportClose();
  };

  // View function
  const handleView = (row) => {
    console.log('View booking:', row);
    setSelectedBooking(row);
    setViewDialogOpen(true);
  };

  const handleCloseViewDialog = () => {
    setViewDialogOpen(false);
    setSelectedBooking(null);
  };

  // Filter data based on current filters
  const filteredData = sampleData.filter(item => {
    const matchesBranch = filters.branch === '' || filters.branch === 'All' || item.branch === filters.branch;
    const matchesSearch = filters.searchTerm === '' ||
      item.customerName.toLowerCase().includes(filters.searchTerm.toLowerCase()) ||
      item.bookingId.toLowerCase().includes(filters.searchTerm.toLowerCase());
    return matchesBranch && matchesSearch;
  });

  const totals = {
    totalBookings: filteredData.length,
    totalAmount: filteredData.reduce((sum, item) => sum + item.plotAmount, 0),
    totalPaid: filteredData.reduce((sum, item) => sum + item.paidAmount, 0),
    totalDue: filteredData.reduce((sum, item) => sum + (item.plotAmount - item.paidAmount), 0)
  };

  return (
    <Box sx={{ p: 3, backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'flex-start', sm: 'center' }} gap={2}>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 700, color: '#000', mb: 0.5 }}>
              Branch Summary Details
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Detailed view of branch-wise booking information
            </Typography>
          </Box>
          <Button
            variant="contained"
            startIcon={<Download />}
            onClick={handleExportClick}
            sx={{
              width: { xs: '100%', sm: 'auto' },
              textTransform: 'none',
              fontWeight: 600,
              backgroundColor: '#536DFE',
              borderRadius: 2,
              px: 3,
              py: 1.5,
              '&:hover': {
                backgroundColor: '#3F51B5',
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 12px rgba(83, 109, 254, 0.3)'
              }
            }}
          >
            Export Data
          </Button>
        </Box>
      </Box>

      {/* Summary Cards */}
      {/* <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ boxShadow: '0 2px 12px rgba(0,0,0,0.1)', borderRadius: 2, p: 3, textAlign: 'center', bgcolor: '#fff' }}>
            <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
              <Business sx={{ fontSize: 40, color: '#536DFE', mr: 1 }} />
              <Typography variant="h4" sx={{ fontWeight: 700, color: '#000' }}>
                {totals.totalBookings}
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
              Total Bookings
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ boxShadow: '0 2px 12px rgba(0,0,0,0.1)', borderRadius: 2, p: 3, textAlign: 'center', bgcolor: '#fff' }}>
            <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
              <TrendingUp sx={{ fontSize: 40, color: '#4caf50', mr: 1 }} />
              <Typography variant="h4" sx={{ fontWeight: 700, color: '#000' }}>
                ₹{(totals.totalAmount / 100000).toFixed(1)}L
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
              Total Amount
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ boxShadow: '0 2px 12px rgba(0,0,0,0.1)', borderRadius: 2, p: 3, textAlign: 'center', bgcolor: '#fff' }}>
            <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
              <CheckCircle sx={{ fontSize: 40, color: '#4caf50', mr: 1 }} />
              <Typography variant="h4" sx={{ fontWeight: 700, color: '#000' }}>
                ₹{(totals.totalPaid / 100000).toFixed(1)}L
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
              Paid Amount
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ boxShadow: '0 2px 12px rgba(0,0,0,0.1)', borderRadius: 2, p: 3, textAlign: 'center', bgcolor: '#fff' }}>
            <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
              <Schedule sx={{ fontSize: 40, color: '#ff9800', mr: 1 }} />
              <Typography variant="h4" sx={{ fontWeight: 700, color: '#000' }}>
                ₹{(totals.totalDue / 100000).toFixed(1)}L
              </Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
              Due Amount
            </Typography>
          </Card>
        </Grid>
      </Grid> */}

      {/* Filters */}
      <Card sx={{ mb: 3, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2 }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
            Branch Summary Filters
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel>Branch</InputLabel>
                <Select
                  value={filters.branch}
                  onChange={(e) => handleFilterChange('branch', e.target.value)}
                  label="Branch"
                >
                  {branches.map(branch => (
                    <MenuItem key={branch} value={branch}>{branch}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                size="small"
                label="From Date"
                type="date"
                value={filters.fromDate}
                onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                size="small"
                label="To Date"
                type="date"
                value={filters.toDate}
                onChange={(e) => handleFilterChange('toDate', e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                fullWidth
                size="small"
                label="Search"
                value={filters.searchTerm}
                onChange={(e) => handleFilterChange('searchTerm', e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* Data Table */}
      <Card sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2 }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
            Branch Summary Details
          </Typography>
          <TableContainer sx={{ overflowX: 'auto' }}>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#536DFE' }}>
                  <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>S.No</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>Booking ID</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>Customer Name</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>Plot No</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>Booking Date</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px', textAlign: 'right' }}>Plot Amount (Rs.)</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px', textAlign: 'right' }}>Paid Amount (Rs.)</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px', textAlign: 'right' }}>Due Amount (Rs.)</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px', textAlign: 'center' }}>Status</TableCell>
                  <TableCell sx={{ color: '#fff', fontWeight: 700, fontSize: '14px', textAlign: 'center' }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={10} sx={{ textAlign: 'center', py: 4 }}>
                      <Typography variant="body1" color="text.secondary">
                        No booking data found for the selected filters
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                    <TableRow
                      key={row.sno}
                      sx={{
                        '&:nth-of-type(odd)': { backgroundColor: '#f8f9fa' },
                        '&:hover': { backgroundColor: '#e3f2fd' }
                      }}
                    >
                      <TableCell sx={{ fontWeight: 600 }}>{page * rowsPerPage + index + 1}</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>{row.bookingId}</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>{row.customerName}</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>{row.plotNo}</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>{row.bookingDate}</TableCell>
                      <TableCell sx={{ fontWeight: 600, textAlign: 'right', fontFamily: 'monospace' }}>
                        Rs. {row.plotAmount.toLocaleString()}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 600, textAlign: 'right', fontFamily: 'monospace' }}>
                        Rs. {row.paidAmount.toLocaleString()}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 600, textAlign: 'right', fontFamily: 'monospace' }}>
                        Rs. {(row.plotAmount - row.paidAmount).toLocaleString()}
                      </TableCell>
                      <TableCell sx={{ textAlign: 'center' }}>
                        <Chip
                          label={row.status}
                          size="small"
                          color={row.status === 'Alloted' ? 'success' : 'primary'}
                          sx={{ fontWeight: 600 }}
                        />
                      </TableCell>
                      <TableCell sx={{ textAlign: 'center' }}>
                        <Tooltip title="View Details">
                          <IconButton
                            size="small"
                            onClick={() => {
                              console.log('View button clicked for row:', row);
                              handleView(row);
                            }}
                            sx={{
                              color: '#1976d2',
                              '&:hover': {
                                backgroundColor: '#e3f2fd',
                                transform: 'scale(1.1)'
                              }
                            }}
                          >
                            <Visibility fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                )}
                {filteredData.length > 0 && (
                  <TableRow sx={{ backgroundColor: '#f0f0f0', fontWeight: 'bold' }}>
                    <TableCell colSpan={5} sx={{ fontWeight: 700, fontSize: '16px' }}>
                      <strong>Total</strong>
                    </TableCell>
                    <TableCell sx={{ fontWeight: 700, textAlign: 'right', fontFamily: 'monospace', fontSize: '16px' }}>
                      <strong>Rs. {totals.totalAmount.toLocaleString()}</strong>
                    </TableCell>
                    <TableCell sx={{ fontWeight: 700, textAlign: 'right', fontFamily: 'monospace', fontSize: '16px' }}>
                      <strong>Rs. {totals.totalPaid.toLocaleString()}</strong>
                    </TableCell>
                    <TableCell sx={{ fontWeight: 700, textAlign: 'right', fontFamily: 'monospace', fontSize: '16px' }}>
                      <strong>Rs. {totals.totalDue.toLocaleString()}</strong>
                    </TableCell>
                    <TableCell colSpan={2}></TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              '& .MuiTablePagination-toolbar': {
                backgroundColor: '#f8f9fa',
              }
            }}
          />
        </CardContent>
      </Card>

      {/* Export Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleExportClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            minWidth: 180,
          }
        }}
      >
        <MenuItem
          onClick={() => handleExport('pdf')}
          sx={{
            '&:hover': {
              backgroundColor: '#f5f5f5',
            }
          }}
        >
          <ListItemIcon>
            <PictureAsPdf fontSize="small" color="error" />
          </ListItemIcon>
          Export as PDF
        </MenuItem>
        <MenuItem
          onClick={() => handleExport('csv')}
          sx={{
            '&:hover': {
              backgroundColor: '#f5f5f5',
            }
          }}
        >
          <ListItemIcon>
            <Description fontSize="small" color="primary" />
          </ListItemIcon>
          Export as CSV
        </MenuItem>
      </Menu>

      {/* Booking Details Dialog */}
      <Dialog
        open={viewDialogOpen}
        onClose={handleCloseViewDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          }
        }}
      >
        <DialogTitle sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#536DFE',
          color: 'white',
          fontWeight: 700
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Visibility />
            <Typography variant="h6">Booking Details</Typography>
          </Box>
          <IconButton
            onClick={handleCloseViewDialog}
            sx={{ color: 'white' }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 3 }}>
          {selectedBooking && (
            <Box>
              {/* Header Section */}
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, p: 2, backgroundColor: '#f8f9fa', borderRadius: 2 }}>
                <Avatar sx={{ backgroundColor: '#536DFE', mr: 2, width: 56, height: 56 }}>
                  <Person sx={{ fontSize: 32 }} />
                </Avatar>
                <Box>
                  <Typography variant="h5" sx={{ fontWeight: 700, color: '#333', mb: 0.5 }}>
                    {selectedBooking.customerName}
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#666', fontWeight: 600 }}>
                    Booking ID: {selectedBooking.bookingId}
                  </Typography>
                  <Chip
                    label={selectedBooking.status}
                    size="small"
                    color={selectedBooking.status === 'Alloted' ? 'success' : 'primary'}
                    sx={{ mt: 1, fontWeight: 600 }}
                  />
                </Box>
              </Box>

              <Divider sx={{ mb: 3 }} />

              {/* Details Grid */}
              <Grid container spacing={3}>
                {/* Booking Information */}
                <Grid item xs={12} md={6}>
                  <Card sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2 }}>
                    <CardContent>
                      <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#536DFE', display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Home />
                        Property Details
                      </Typography>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Typography variant="body2" color="text.secondary">Plot Number:</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedBooking.plotNo}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Typography variant="body2" color="text.secondary">Branch:</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedBooking.branch}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Typography variant="body2" color="text.secondary">Booking Date:</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>{selectedBooking.bookingDate}</Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Financial Information */}
                <Grid item xs={12} md={6}>
                  <Card sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2 }}>
                    <CardContent>
                      <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#536DFE', display: 'flex', alignItems: 'center', gap: 1 }}>
                        <AttachMoney />
                        Financial Details
                      </Typography>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Typography variant="body2" color="text.secondary">Plot Amount:</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 600, fontFamily: 'monospace' }}>
                            Rs. {selectedBooking.plotAmount.toLocaleString()}
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Typography variant="body2" color="text.secondary">Paid Amount:</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 600, fontFamily: 'monospace', color: '#2e7d32' }}>
                            Rs. {selectedBooking.paidAmount.toLocaleString()}
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Typography variant="body2" color="text.secondary">Due Amount:</Typography>
                          <Typography variant="body2" sx={{ fontWeight: 600, fontFamily: 'monospace', color: '#d32f2f' }}>
                            Rs. {(selectedBooking.plotAmount - selectedBooking.paidAmount).toLocaleString()}
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Typography variant="body2" color="text.secondary">Payment Status:</Typography>
                          <Chip
                            label={selectedBooking.paidAmount === selectedBooking.plotAmount ? 'Fully Paid' :
                              selectedBooking.paidAmount > 0 ? 'Partially Paid' : 'Not Paid'}
                            size="small"
                            color={selectedBooking.paidAmount === selectedBooking.plotAmount ? 'success' :
                              selectedBooking.paidAmount > 0 ? 'warning' : 'error'}
                            sx={{ fontWeight: 600 }}
                          />
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Additional Information */}
                <Grid item xs={12}>
                  <Card sx={{ boxShadow: '0 2px 8px rgba(0,0,0,0.08)', borderRadius: 2 }}>
                    <CardContent>
                      <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#536DFE', display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CalendarToday />
                        Additional Information
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                          <Box sx={{ textAlign: 'center', p: 2, backgroundColor: '#f8f9fa', borderRadius: 2 }}>
                            <Typography variant="h4" sx={{ fontWeight: 700, color: '#536DFE' }}>
                              {Math.round((selectedBooking.paidAmount / selectedBooking.plotAmount) * 100)}%
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
                              Payment Progress
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box sx={{ textAlign: 'center', p: 2, backgroundColor: '#f8f9fa', borderRadius: 2 }}>
                            <Typography variant="h4" sx={{ fontWeight: 700, color: '#2e7d32' }}>
                              ₹{selectedBooking.paidAmount.toLocaleString()}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
                              Total Paid
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box sx={{ textAlign: 'center', p: 2, backgroundColor: '#f8f9fa', borderRadius: 2 }}>
                            <Typography variant="h4" sx={{ fontWeight: 700, color: '#d32f2f' }}>
                              ₹{(selectedBooking.plotAmount - selectedBooking.paidAmount).toLocaleString()}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
                              Remaining Amount
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ p: 3, backgroundColor: '#f8f9fa' }}>
          <Button
            onClick={handleCloseViewDialog}
            variant="contained"
            sx={{
              backgroundColor: '#536DFE',
              '&:hover': { backgroundColor: '#3F51B5' },
              textTransform: 'none',
              fontWeight: 600,
              px: 3
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
};

export default BranchSummaryDetails;

